module.exports = __webpack_public_path__ + "img/button_delete_highlights.a043e858.svg";